import React from "react";
import SkipAheadButton from "./SkipAheadButton";

// skip to footer nav controls a11y keyboard aid
const SkipFooterButton: React.FC = () => {
  return (
    <SkipAheadButton
      captionId={"base.skipFooter"}
      action={() => document.querySelector<HTMLDivElement>("footer")!.focus()}
    />
  );
};

export default SkipFooterButton;
